import { render, staticRenderFns } from "./VasItem.vue?vue&type=template&id=4de4bb9a&scoped=true&"
import script from "./VasItem.vue?vue&type=script&lang=ts&"
export * from "./VasItem.vue?vue&type=script&lang=ts&"
import style0 from "./VasItem.vue?vue&type=style&index=0&id=4de4bb9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de4bb9a",
  null
  
)

export default component.exports